module.exports = __webpack_public_path__ + "pk.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/pk.svg
// module id = 1013
// module chunks = 0